// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteLeads_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /config/site_leads/lista — the log's filters and page
 * window, read from the query string.
 *
 * `formulario` is NOT validated against a list: the set of forms belongs to the
 * site's tenant pack and this service must not hold a second copy of it. An
 * unknown slug simply matches nothing. The window IS clamped, in the model,
 * because an unbounded LIMIT is a real cost.
 */
import { registerContract } from './validate'

export interface SiteLeads_ListaInput {
formulario?: string
de?: string
ate?: string
limit?: number
offset?: number
finalidade?: string
}

registerContract('SiteLeads_ListaInput', {
  formulario: { type: 'string',  required: false },
  de:         { type: 'string',  required: false },
  ate:        { type: 'string',  required: false },
  limit:      { type: 'number',  required: false },
  offset:     { type: 'number',  required: false },
  finalidade: { type: 'string',  required: false },
})
